import './App.css';
import PosturaDetector from './PosturaDetector';

function App() {
  return (
    <div className="App">
      <PosturaDetector />
    </div>
  );
}

export default App;
